import { Link } from "@tanstack/react-router";
import type { RenderLink } from "@h2j-data-team/ui";

/**
 * Router adapter for the library's NavigationMenu, ActionMenu and Breadcrumbs.
 * The item's href may carry a query string (`/jobs?status=failed`), which
 * TanStack takes as `search`, not as part of `to`. The library computes
 * `aria-current` from the item, so the Link only matches exactly and never marks
 * a parent path as current on its own.
 */
export const renderLink: RenderLink = ({ href = "", ...props }) => {
  const url = new URL(href, "http://app.local");
  const search = Object.fromEntries(url.searchParams);
  return (
    <Link
      to={url.pathname as never}
      search={(Object.keys(search).length ? search : undefined) as never}
      activeOptions={{ exact: true, includeSearch: true }}
      {...props}
    />
  );
};
